var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgControllerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5041 7.91675H7.50411C7.04578 7.91675 6.67078 8.29175 6.67078 8.75008V18.7501C6.67078 19.2084 7.04578 19.5834 7.50411 19.5834H12.5041C12.9624 19.5834 13.3374 19.2084 13.3374 18.7501V8.75008C13.3374 8.29175 12.9624 7.91675 12.5041 7.91675ZM10.0041 12.2917C9.42911 12.2917 8.96244 11.8251 8.96244 11.2501C8.96244 10.6751 9.42911 10.2084 10.0041 10.2084C10.5791 10.2084 11.0458 10.6751 11.0458 11.2501C11.0458 11.8251 10.5791 12.2917 10.0041 12.2917Z",
    fill: "#6CCCDF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5041 7.91675H7.50411C7.04578 7.91675 6.67078 8.29175 6.67078 8.75008V18.7501C6.67078 19.2084 7.04578 19.5834 7.50411 19.5834H12.5041C12.9624 19.5834 13.3374 19.2084 13.3374 18.7501V8.75008C13.3374 8.29175 12.9624 7.91675 12.5041 7.91675ZM10.0041 12.2917C9.42911 12.2917 8.96244 11.8251 8.96244 11.2501C8.96244 10.6751 9.42911 10.2084 10.0041 10.2084C10.5791 10.2084 11.0458 10.6751 11.0458 11.2501C11.0458 11.8251 10.5791 12.2917 10.0041 12.2917Z",
    fill: "url(#paint0_linear_127_13994)",
    fillOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.52078 6.10008C6.81244 6.39175 7.27078 6.41675 7.60411 6.18341C8.27911 5.70008 9.11244 5.41675 10.0041 5.41675C10.8958 5.41675 11.7291 5.70008 12.4041 6.17508C12.7374 6.40841 13.1958 6.39175 13.4874 6.10008C13.8458 5.74175 13.8124 5.14175 13.4124 4.85008C12.4541 4.15842 11.2791 3.75008 10.0041 3.75008C8.72911 3.75008 7.55411 4.15842 6.59578 4.85008C6.18744 5.14175 6.16244 5.74175 6.52078 6.10008Z",
    fill: "#6CCCDF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.52078 6.10008C6.81244 6.39175 7.27078 6.41675 7.60411 6.18341C8.27911 5.70008 9.11244 5.41675 10.0041 5.41675C10.8958 5.41675 11.7291 5.70008 12.4041 6.17508C12.7374 6.40841 13.1958 6.39175 13.4874 6.10008C13.8458 5.74175 13.8124 5.14175 13.4124 4.85008C12.4541 4.15842 11.2791 3.75008 10.0041 3.75008C8.72911 3.75008 7.55411 4.15842 6.59578 4.85008C6.18744 5.14175 6.16244 5.74175 6.52078 6.10008Z",
    fill: "url(#paint1_linear_127_13994)",
    fillOpacity: 0.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0041 0.416748C7.80411 0.416748 5.78744 1.19175 4.21244 2.47508C3.82911 2.79175 3.79578 3.36675 4.14578 3.71675C4.44578 4.01675 4.92078 4.04175 5.24578 3.77508C6.53744 2.72508 8.19578 2.08341 10.0041 2.08341C11.8124 2.08341 13.4708 2.72508 14.7541 3.78341C15.0791 4.05008 15.5541 4.02508 15.8541 3.72508C16.2041 3.37508 16.1708 2.80008 15.7874 2.48341C14.2208 1.19175 12.2041 0.416748 10.0041 0.416748Z",
    fill: "#6CCCDF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0041 0.416748C7.80411 0.416748 5.78744 1.19175 4.21244 2.47508C3.82911 2.79175 3.79578 3.36675 4.14578 3.71675C4.44578 4.01675 4.92078 4.04175 5.24578 3.77508C6.53744 2.72508 8.19578 2.08341 10.0041 2.08341C11.8124 2.08341 13.4708 2.72508 14.7541 3.78341C15.0791 4.05008 15.5541 4.02508 15.8541 3.72508C16.2041 3.37508 16.1708 2.80008 15.7874 2.48341C14.2208 1.19175 12.2041 0.416748 10.0041 0.416748Z",
    fill: "url(#paint2_linear_127_13994)",
    fillOpacity: 0.7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_127_13994",
    x1: 4.77385,
    y1: -1.18045,
    x2: 16.1528,
    y2: -0.959821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0085FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932292,
    stopColor: "#0085FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_127_13994",
    x1: 4.77385,
    y1: -1.18045,
    x2: 16.1528,
    y2: -0.959821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0085FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932292,
    stopColor: "#0085FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_127_13994",
    x1: 4.77385,
    y1: -1.18045,
    x2: 16.1528,
    y2: -0.959821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0085FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932292,
    stopColor: "#0085FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControllerIcon);
export default __webpack_public_path__ + "static/media/controllerIcon.939efa7adcb91aed97df73ca64409124.svg";
export { ForwardRef as ReactComponent };